import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BRAND_NAME } from "@/config";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && user) navigate("/admin/dashboard");
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate("/admin/dashboard");
    else setError(res.error);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-secondary px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm border border-border bg-white p-10">
        <Link to="/" className="mb-2 block text-center font-serif text-2xl tracking-[0.15em] text-stone-900">{BRAND_NAME}</Link>
        <p className="mb-10 text-center text-[10px] uppercase tracking-[0.3em] text-stone-400">Admin Access</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="text" placeholder="Username" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          <input data-testid="login-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-wine py-3.5 text-[11px] uppercase tracking-[0.2em] text-white transition-colors hover:bg-wine-hover disabled:opacity-60">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}

const inputCls = "w-full border border-input bg-white px-4 py-3 text-sm text-stone-900 outline-none placeholder:text-stone-400 focus:border-wine";
